import axios from 'axios'
import {
	message
} from 'antd';


// console.log(process.env)
const baseUrl = process.env.REACT_APP_ENV === "production" ? process.env.REACT_APP_BASE_URL + 'video-wechat-manager/api' : "https://xy-xxz-admin.aixyhl.cn/video-wechat-manager/api";
// const baseUrl = "http://192.168.66.12:8686/video-wechat-manager/api/"
//const baseUrl = 'http://wechat-admin.qfedu.com/video-wechat-manager/api/'
let instance = axios.create({
	baseURL: baseUrl,
	timeout: 36000000,
	headers: {},
	//       // 发送请求参数是对象的或者是表单需要加上以下代码
	//   transformRequest: function(data) {
	//       if (data.toLocaleString() == '[object FormData]')
	//           return data;
	//       return qs.stringify(data)
	//   }
});
instance.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
instance.interceptors.request.use(function (config) {
	// 在发送请求之前做些什么
	if (localStorage.getItem('token')) {
		config.headers.Authorization = localStorage.getItem('token');
	}
	return config;
}, function (error) {
	// 对请求错误做些什么
	console.log(error, 'axioserror')
	return Promise.reject(error);
});

function debounce(fn, wait) {
	let timerId = null;
	let flag = true;
	return function () {
		clearTimeout(timerId);
		if (flag) {
			fn.apply(this, arguments);
			flag = false;
			timerId = setTimeout(() => {
				sessionStorage.clear()
				localStorage.clear()
				window.location.reload()
				flag = false;
			}, wait);
		}
	};
}
const authError = debounce(msg => {
	message.error(msg);
}, 1000);
// 添加响应拦截器
instance.interceptors.response.use(function (response) {
	if (response.data.code && response.data.code === "900") {
		authError(response.data.msg)
	} else if (response.data.code && response.data.code === "901") {
		authError(response.data.msg)
	} else if (response.data.code && (response.data.code === "903" || response.data.code === 903)) {
		// authError(response.data.msg)
		message.error(response.data.msg);
		sessionStorage.clear()
		localStorage.clear()
		window.location.reload()
	} else if (response.data.code && (response.data.code === "999" || response.data.code === 999)) {
		message.error(response.data.msg);
	}

	return response;
}, function (error) {
	// 对响应错误做点什么
	// ElMessage.error('系统问题，请稍后重试或者联系相关人员');
	console.log(error)
	return Promise.reject(error);
});
export default instance
